import React from 'react'
import PropTypes from 'prop-types'

const statusIcons = {
  completed: 'fa-regular fa-circle-check text-success',
  active: 'fa-regular fa-circle-dot text-primary',
  pending: 'fa-regular fa-circle text-muted',
}

export const TaskItem = ({ task, index }) => {
  const iconClass = statusIcons[task.status] || statusIcons.pending

  return (
    <div
      className={`simulation-task-item simulation-task-${task.status}`}
      role="listitem"
      aria-current={task.status === 'active' ? 'step' : undefined}
    >
      <div className="simulation-task-icon">
        <i className={iconClass} aria-hidden="true" />
      </div>
      <div className="simulation-task-content">
        <div className="simulation-task-title">
          <span className="simulation-task-number">{index + 1}.</span>{' '}
          {task.title}
        </div>
        {task.status === 'active' && task.description && (
          <div className="simulation-task-description">{task.description}</div>
        )}
      </div>
    </div>
  )
}

TaskItem.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    status: PropTypes.oneOf(['pending', 'active', 'completed']).isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
}
